import React from 'react';
import atomize from "@quarkly/atomize";
import styled from "styled-components";
import { useOverrides } from "@quarkly/components";
import { Box, Text, Icon } from "@quarkly/widgets";
import { MdClose } from "react-icons/md";
const overrides = {
	"Popup": {
		kind: "Box",
		props: {
			top: '0',
			left: '0',
			width: '100%',
			height: '100%',
			'align-items': 'center',
			'justify-content': 'center',
			display: 'flex',
			position: 'fixed',
			'z-index': '105'
		}
	},
	"Overlay": {
		kind: "Box",
		props: {
			top: '0',
			left: '0',
			width: '100%',
			height: '100%',
			position: 'fixed',
			'z-index': '106',
			"background-color": "rgba(0, 0, 0, 0.2)",
			cursor: "pointer"
		}
	},
	"PopupInner": {
		kind: "Box",
		props: {
			'min-width': '320px',
			'box-shadow': `
          0 14px 28px rgba(0,0,0,0.25),
          0 10px 10px rgba(0,0,0,0.22)
      `,
			position: 'relative',
			overflow: 'hidden',
			display: 'flex',
			'z-index': '107',
			padding: "0px",
			"overflow-y": "auto",
			"background-color": "#010a13",
			cursor: "default"
		}
	},
	"CloseBtn": {
		kind: "Button",
		props: {
			position: "absolute",
			top: "16px",
			right: "16px",
			category: "md",
			icon: MdClose,
			size: "64px",
			color: "white",
			cursor: "pointer"
		}
	},
	"Title": {
		kind: "Text",
		props: {
			color: "#E4E8EC",
			margin: "0px 0px 0px 0px",
			font: "--headline2",
			"border-color": "#70189f",
			position: "static",
			padding: "0px 0px 0px 0px"
		}
	},
	"Titles": {
		kind: "Text",
		props: {
			color: "#E4E8EC",
			margin: "0px 0px 0px 0px",
			font: "--headline4",
			"border-color": "#70189f",
			position: "static",
			padding: "0px 0px 0px 0px"
		}
	},
	"ListItem": {
		kind: "Text",
		props: {
			color: "#E4E8EC",
			margin: "0px 0px 0px 0px",
			font: "--leads"
		}
	},
	"ListItems": {
		kind: "Text",
		props: {
			color: "#E4E8EC",
			margin: "0px 0px 0px 0px",
			font: "--lead"
		}
	},
	"ListItemz": {
		kind: "Text",
		props: {
			color: "#6F839F",
			margin: "0px 0px 0px 0px",
			font: "--leads"
		}
	}
};

const Popup = ({
	src,
	...props
}) => {
	const {
		override,
		rest
	} = useOverrides(props, overrides);
	return props.trigger.open ? <Box {...override("Popup")}>
		      
		<Box {...override("Overlay")} onClick={() => props.setTrigger({
			open: false
		})} />
		      
		<Box {...override("PopupInner")} background={`#010a13 url(${props.trigger.imgsrc ? props.trigger.imgsrc : 'none'}) bottom/100% no-repeat scroll`} imgsrc={props.trigger.imgsrc}>
			        
			<Icon {...override("CloseBtn")} onClick={() => props.setTrigger({
				open: false
			})}>
				close
			</Icon>
			        
			<Text {...override("Title")}>
				{props.trigger.title}
			</Text>
			        
			<Text {...override("Titles")}>
				{props.trigger.titles}
			</Text>
			        
			<ol>
				        
				<Text {...override("ListItems")}>
					 
					{props.trigger.s1}
				</Text>
				        
				<Text {...override("ListItems")}>
					 
					{props.trigger.s2}
				</Text>
				        
				<Text {...override("ListItems")}>
					 
					{props.trigger.s3}
				</Text>
				        
				<Text {...override("ListItems")}>
					 
					{props.trigger.s4}
				</Text>
				        
				<Text {...override("ListItems")}>
					 
					{props.trigger.s5}
				</Text>
				        
				<Text {...override("ListItems")}>
					 
					{props.trigger.s6}
				</Text>
				        
				<Text {...override("ListItems")}>
					 
					{props.trigger.s7}
				</Text>
				        
				<Text {...override("ListItem")}>
					 
					{props.trigger.player1}
				</Text>
				        
				<Text {...override("ListItem")}>
					 
					{props.trigger.player2}
				</Text>
				        
				<Text {...override("ListItemz")}>
					 
					{props.trigger.player3}
				</Text>
				        
				<Text {...override("ListItemz")}>
					 
					{props.trigger.player4}
				</Text>
				        
				<Text {...override("ListItemz")}>
					 
					{props.trigger.player5}
				</Text>
				        
				<Text {...override("ListItemz")}>
					 
					{props.trigger.player6}
				</Text>
				        
				<Text {...override("ListItemz")}>
					 
					{props.trigger.player7}
				</Text>
				        
			</ol>
			        
			{props.children}
			      
		</Box>
		    
	</Box> : "";
};

export default Object.assign(Popup, {
	title: "Popup component",
	overrides
});